import { useEffect } from 'react';
import { connect, FormikContextType } from 'formik';
import { ExtendedEventSeries } from '../../../extendedEventSeries.model';
import { useDateFns } from '~/Hooks';
import { format } from 'date-fns';
import { TIME_FREQUENCY } from '~/Models/DTO/EventSeries.model';

export interface EventScheduleTimeSeriesFrequencyNoneProps {
  startDate: string;
}

export const EventScheduleTimeSeriesFrequencyNone = connect<
  EventScheduleTimeSeriesFrequencyNoneProps,
  ExtendedEventSeries
>(
  ({
    formik,
    startDate,
  }: EventScheduleTimeSeriesFrequencyNoneProps & {
    formik: FormikContextType<ExtendedEventSeries>;
  }) => {
    const { addTime } = useDateFns();

    useEffect(() => {
      setTimeout(() => {
        formik.setValues((prev) => ({
          ...prev,
          byMonthDay: null,
          bySetPos: null,
          frequency: TIME_FREQUENCY.WEEKLY,
          endDate: addTime(startDate, { days: 1 }).toISOString(),
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          [format(new Date(startDate), 'eeee').toLowerCase()]: true,
        }));
      }, 0);
    }, [startDate]);

    return null;
  },
);
